import { actionCreators } from './UserSettingsState';
import { State } from '@progress/kendo-data-query';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { ReportFilter } from '../../Interfaces/Reports/ReportFilter';
import { WidgetsState } from '../../Interfaces/Overview/WidgetsState';
import { TrendsFilter } from '../../Interfaces/Devices/Trends/TrendsFilter';
import { IdentityManagerType } from '../../Interfaces/SSO/IdentityManagerConfiguration';

export const setIdentityMgrType = async (
  dispatch: any,
  idMgrType: IdentityManagerType,
) => {
  return dispatch(actionCreators.setIdentityMgrType(idMgrType));
};

export const setAlertsRefreshRate = async (dispatch: any, value: number) => {
  return dispatch(actionCreators.setAlertsRefreshRate(value));
};

export const saveAlertsGridState = async (dispatch: any, state: State) => {
  return dispatch(actionCreators.saveUserSelectedAlertsFilter(state));
};

export const saveNodesGridState = async (dispatch: any, state: State) => {
  return dispatch(actionCreators.saveUserSelectedNodesFilter(state));
};

export const saveAssetStatusesGridState = async (
  dispatch: any,
  state: State,
) => {
  return dispatch(actionCreators.saveAssetStatusesGridState(state));
};

export const saveVersionsGridState = async (dispatch: any, state: State) => {
  return dispatch(actionCreators.saveVersionsGridState(state));
};

export const saveProductsHealthGridState = async (
  dispatch: any,
  state: State,
) => {
  return dispatch(actionCreators.saveProductsHealthGridState(state));
};

export const saveTicketsGridState = async (dispatch: any, state: State) => {
  return dispatch(actionCreators.saveTicketsGridState(state));
};

export const saveNodesFilters = async (
  dispatch: any,
  filters: CompositeFilterDescriptor,
) => {
  return dispatch(actionCreators.saveNodesFilters(filters));
};

export const saveTicketFilters = async (
  dispatch: any,
  filters: CompositeFilterDescriptor,
) => {
  return dispatch(actionCreators.saveTicketFilters(filters));
};

export const saveAssetStatusesFilters = async (
  dispatch: any,
  filters: CompositeFilterDescriptor,
) => {
  return dispatch(actionCreators.saveAssetStatusesFilters(filters));
};

export const setAssetsSummaryVisibility = async (
  dispatch: any,
  showAssetsSummary: boolean | undefined,
) => {
  return dispatch(actionCreators.setAssetsSummaryVisibility(showAssetsSummary));
};

export const setDeviceStatusSummaryVisibility = async (
  dispatch: any,
  showDeviceStatusSummary: boolean | undefined,
) => {
  return dispatch(
    actionCreators.setDeviceStatusSummaryVisibility(showDeviceStatusSummary),
  );
};

export const setAlertsSummaryVisibility = async (
  dispatch: any,
  showAlertsSummary: boolean | undefined,
) => {
  return dispatch(actionCreators.setAlertsSummaryVisibility(showAlertsSummary));
};

export const saveReportFilter = async (
  dispatch: any,
  reportFilter: ReportFilter,
) => {
  return dispatch(actionCreators.saveReportFilter(reportFilter));
};

export const setSelectedLanguage = async (dispatch: any, value: string) => {
  return dispatch(actionCreators.setSaveSelectedLanguage(value));
};

export const setTicketsSummaryVisibility = async (
  dispatch: any,
  showTicketsSummary: boolean | undefined,
) => {
  return dispatch(
    actionCreators.setTicketsSummaryVisibility(showTicketsSummary),
  );
};

export const setHealthSummaryVisibility = async (
  dispatch: any,
  showHealthSummary: boolean | undefined,
) => {
  return dispatch(actionCreators.setHealthSummaryVisibility(showHealthSummary));
};

export const saveHealthFilters = async (
  dispatch: any,
  filters: CompositeFilterDescriptor,
) => {
  return dispatch(actionCreators.saveHealthFilters(filters));
};

export const saveProductsHealthFilters = async (
  dispatch: any,
  filters: CompositeFilterDescriptor,
) => {
  return dispatch(actionCreators.saveProductsHealthFilters(filters));
};

export const saveWidgetsState = async (
  dispatch: any,
  widgetState: WidgetsState[],
) => {
  return dispatch(actionCreators.saveWidgetsState(widgetState));
};

export const saveDeviceTrendsFilter = async (
  dispatch: any,
  deviceTrendsFilter: TrendsFilter,
) => {
  return dispatch(actionCreators.saveDeviceTrendsFilter(deviceTrendsFilter));
};

export const saveDeviceIssueTrendsGridState = async (
  dispatch: any,
  state: State,
) => {
  return dispatch(actionCreators.saveDeviceIssueTrendsGridState(state));
};

export const saveNodesConfigGridState = async (dispatch: any, state: State) => {
  return dispatch(actionCreators.saveUserSelectedNodesConfigGridState(state));
};

export const saveNodesJsonConfigGridState = async (
  dispatch: any,
  state: State,
) => {
  return dispatch(
    actionCreators.saveUserSelectedNodesJsonConfigGridState(state),
  );
};

export const saveNodesConfigFilters = async (
  dispatch: any,
  filters: CompositeFilterDescriptor,
) => {
  return dispatch(actionCreators.saveNodesConfigFilters(filters));
};

export const saveNodesJsonConfigFilters = async (
  dispatch: any,
  filters: CompositeFilterDescriptor,
) => {
  return dispatch(actionCreators.saveNodesJsonConfigFilters(filters));
};

export const savePrevMaintenanceGridState = async (
  dispatch: any,
  state: State,
) => {
  return dispatch(actionCreators.savePrevMaintenanceGridState(state));
};

export const savePrevMaintenanceFilters = async (
  dispatch: any,
  filters: CompositeFilterDescriptor,
) => {
  return dispatch(actionCreators.savePrevMaintenanceFilters(filters));
};

export const savePredMaintenanceGridState = async (
  dispatch: any,
  state: State,
) => {
  return dispatch(actionCreators.savePredMaintenanceGridState(state));
};

export const savePredMaintenanceFilters = async (
  dispatch: any,
  filters: CompositeFilterDescriptor,
) => {
  return dispatch(actionCreators.savePredMaintenanceFilters(filters));
};

export const saveSelectedProfile = async (
  dispatch: any,
  selectedProfile: string | undefined,
) => {
  return dispatch(actionCreators.saveSelectedProfile(selectedProfile));
};

export const saveFirmwareGridState = async (dispatch: any, state: State) => {
  return dispatch(actionCreators.saveFirmwareGridState(state));
};
